import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import CadProdutoForms from '../FormsTemplates/Produto/CadastroProdutoForms';

export default function CadProduto() {
  
  return (
    <Page title="Produto">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Produto/Serviço
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/produto/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <CadProdutoForms/>    
      </Container>
    </Page>
  );
}
